export default {
  path: '/transactionRecords',
  name: 'TransactionRecords',
  component: () => import('@/views/transactionRecords/TransactionRecordsPage.vue')
}

